/**
 * Processes image cards with arrow symbols (↑ ↓) in figcaption
 * Adds margin-top to the next image card when arrow symbols are found
 */
export function initImageSpacing() {
  const isPostPage = document.body.classList.contains('post-template') || 
                    document.body.classList.contains('page-template') ||
                    document.querySelector('.gh-content, .js-toc-content');
  
  if (!isPostPage) return;

  const contentElement = document.querySelector('.gh-content, .js-toc-content');
  if (!contentElement) return;

  const imageCardsWithCaption = contentElement.querySelectorAll('.kg-image-card.kg-card-hascaption');
  
  if (imageCardsWithCaption.length === 0) return;

  imageCardsWithCaption.forEach((imageCard) => {
    const figcaption = imageCard.querySelector('figcaption');
    if (!figcaption) return;

    const captionText = figcaption.textContent || '';
    
    if (captionText.includes('↑') || captionText.includes('↓')) {
      let nextElement = imageCard.nextElementSibling;
      
      while (nextElement) {
        if (nextElement.classList.contains('kg-image-card')) {
          nextElement.style.marginTop = '0.8rem';
          break;
        }
        nextElement = nextElement.nextElementSibling;
      }
    }
  });
}
